import React from 'react';
import { Link } from 'react-router';
import fileDownload from 'js-file-download';
import { downloadFile } from 'components/utils';
import { checkServerLive } from 'constants/config';
import { ShowIf } from 'components/utils';

class ListHistoryDetailRowItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    const {oldValue, newValue, propertyName} = this.props.item;
    const fileNameOld = oldValue.substr(0, oldValue.indexOf("tcx@"));
    const fileNameNew = newValue.substr(0, newValue.indexOf("tcx@"));
    const oldValueLen = oldValue.length;
    const newValueLen = newValue.length;
    const oldValueDuongDan = oldValue.substr(oldValue.indexOf("http://"), oldValueLen);
    const newValueDuongDan = newValue.substr(newValue.indexOf("http://"), newValueLen);
    return (
      <tr className="row-list-items-giaiquyetdon">
        <td>{(this.props.count) ? this.props.count : ''}</td>
        <td>{propertyName}</td>
        <td>
          <ShowIf condition={this.props.isVanBan}>
            <ShowIf condition={!checkServerLive}>
              <Link className="txt-blue txt-underline" onClick={fileDownload.bind(this, oldValueDuongDan, fileNameOld)}>{fileNameOld}</Link>
            </ShowIf>
            <ShowIf condition={checkServerLive}>
              <Link className="txt-blue txt-underline" onClick={()=>{downloadFile(oldValueDuongDan, fileNameOld)}}>{fileNameOld}</Link>
            </ShowIf>
          </ShowIf>
          <ShowIf condition={!this.props.isVanBan}>
            {oldValue === 'null' ? '' : oldValue}
          </ShowIf>
        </td>
        <td>
          <ShowIf condition={this.props.isVanBan}>
            <ShowIf condition={!checkServerLive}>
              <Link className="txt-blue txt-underline" onClick={fileDownload.bind(this, newValueDuongDan, fileNameNew)}>{fileNameNew}</Link>
            </ShowIf>
            <ShowIf condition={checkServerLive}>
              <Link className="txt-blue txt-underline" onClick={()=>{downloadFile(newValueDuongDan, fileNameNew)}}>{fileNameNew}</Link>
            </ShowIf>
          </ShowIf>
          <ShowIf condition={!this.props.isVanBan}>
            {newValue}
          </ShowIf>
        </td>
      </tr>
    );
  }
}

export default ListHistoryDetailRowItem;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/datatable/rowItem/ListHistoryDetailRowItem.jsx